import type { FiscalDocumentStatus, PosSaleNfce } from "@cx/contracts";
import type { Tone } from "@cx/ui";
import { INVOICE_STATUS_LABEL, INVOICE_STATUS_TONE } from "../invoices/labels";

/** Rótulos do PDV (T3.1). */

export const POS_METHOD_LABEL: Record<string, string> = {
  cash: "Dinheiro",
  pix: "Pix",
  card: "Cartão",
  credit: "Crediário",
  other: "Outros",
};

export const CASH_MOVEMENT_LABEL: Record<string, string> = {
  sale: "Venda",
  change: "Troco",
  supply: "Suprimento",
  withdrawal: "Sangria",
  refund: "Devolução ao cliente",
  adjustment: "Ajuste do fechamento",
};

/** NFC-e da venda: situação, com "contingência" quando tpEmis 9. */
export function nfceLabel(n: PosSaleNfce | null): { text: string; tone: Tone } {
  if (!n) return { text: "Sem NFC-e", tone: "secondary" };
  const s = n.status as FiscalDocumentStatus;
  const base = INVOICE_STATUS_LABEL[s] ?? n.status;
  return {
    text: n.emissionType === 9 && s !== "canceled" ? `${base} (contingência)` : base,
    tone: INVOICE_STATUS_TONE[s] ?? "secondary",
  };
}

export const nfceInFlight = (n: PosSaleNfce | null) => n?.status === "queued" || n?.status === "sending";
